import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from './store/store';

import TopBar from './components/TopBar';
import Sidebar from './components/SideBar';

import StartPage from './pages/StartPage';
import LoginPage from './pages/LoginPage';
import SettingsPage from './pages/SettingsPage';
import ProfilePage from './pages/ProfilePage';
import UserManagementPage from './pages/UserManagementPage';
import TimeEntriesPage from './pages/TimeEntriesPage';
import MonthlyTimesheetPage from './pages/MonthlyTimesheetPage';
import MissingOverviewPage from './pages/MissingOverviewPage';
import TeamPresencePage from './pages/TeamPresencePage';
import ReportsPage from './pages/ReportsPage';
import VacationPage from './pages/VacationPage';
import VacationAdminPage from './pages/VacationAdminPage';
import TimeEntryChangeRequestsPage from './pages/TimeEntryChangeRequestsPage';

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="d-flex">
      <Sidebar />
      <main className="flex-grow-1 p-3">{children}</main>
    </div>
  );
}

function AppWrapper() {
  const isLoggedIn = useSelector((state: RootState) => !!state.auth.token);
  const user = useSelector((state: RootState) => state.auth.user);
  const location = useLocation();
  const showSidebar = location.pathname !== '/login';
  const isAdmin = user?.role === 'admin';

  return (
    <>
      <TopBar />
      {showSidebar ? (
        <Layout>
          <Routes>
            <Route path="/" element={isLoggedIn ? <StartPage /> : <Navigate to="/login" replace />} />
            <Route path="/settings" element={isLoggedIn ? <SettingsPage /> : <Navigate to="/login" replace />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/users" element={<UserManagementPage />} />
            <Route path="/time-entries" element={<TimeEntriesPage />} />
            <Route path="/timesheet" element={isLoggedIn ? <MonthlyTimesheetPage /> : <Navigate to="/login" replace />} />
            <Route path="/team" element={isLoggedIn ? <TeamPresencePage /> : <Navigate to="/login" replace />} />
            <Route path="/timesheet-admin" element={isAdmin ? <MissingOverviewPage /> : <Navigate to="/" replace />} />
            <Route path="/work-times" element={<Navigate to="/settings" replace />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/vacation" element={<VacationPage />} />
            <Route path="/vacation-admin" element={<VacationAdminPage />} />
            <Route
              path="/time-entry-change-requests"
              element={isLoggedIn ? <TimeEntryChangeRequestsPage /> : <Navigate to="/login" replace />}
            />
          </Routes>
        </Layout>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      )}
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
